import { motion } from "framer-motion";
import { Banknote, ShieldCheck, RefreshCcw, Wrench, KeyRound } from "lucide-react";

const SERVICES = [
  {
    icon: Banknote,
    title: "Finanziamenti Personalizzati",
    desc: "Rate su misura, anticipo flessibile e approvazione rapida. Costruiamo insieme il piano più adatto al tuo budget.",
  },
  {
    icon: ShieldCheck,
    title: "Sub-Agenzia Assicurativa",
    desc: "Polizze RCA, furto/incendio e Kasko stipulabili direttamente in sede: esci dal concessionario già assicurato.",
  },
  {
    icon: RefreshCcw,
    title: "Valutazione e Ritiro Usato",
    desc: "Permuta rapida e trasparente: valutiamo la tua auto in giornata e la scaliamo direttamente dal prezzo.",
  },
  {
    icon: KeyRound,
    title: "Noleggio Breve e Lungo Termine",
    desc: "Soluzioni di noleggio flessibili e vantaggiose, a breve o lungo termine, adatte a ogni esigenza di mobilità: con la garanzia e l'affidabilità di Manno Auto.",
  },
  {
    icon: Wrench,
    title: "Assistenza Post-Vendita",
    desc: "Garanzia convenzionata 12–24 mesi e rete di officine partner per seguirti anche dopo l'acquisto.",
  },
];

export const Services = () => (
  <section id="servizi" className="py-16 md:py-24 bg-[#0D1119] border-y border-border" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-12"
      >
        <p className="font-mono2 text-xs uppercase tracking-[0.35em] text-amber-500 mb-3">02 / Servizi</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight">
          Tutto per la tua auto, in un unico posto
        </h2>
      </motion.div>

      <div className="divide-y divide-border border-y border-border">
        {SERVICES.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, x: -32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.06 }}
            className="group flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-10 py-7 hover:bg-[#111622] transition-colors px-2 sm:px-4 -mx-2 sm:-mx-4"
            data-testid={`service-row-${i}`}
          >
            <span className="font-display text-4xl sm:text-5xl font-black text-outline group-hover:text-amber-500 group-hover:[-webkit-text-stroke:0px] transition-all w-20 shrink-0">
              {String(i + 1).padStart(2, "0")}
            </span>
            <s.icon className="w-7 h-7 text-amber-500 shrink-0 hidden sm:block" />
            <div className="sm:flex-1">
              <h3 className="font-display text-xl sm:text-2xl font-bold uppercase tracking-snug">{s.title}</h3>
              <p className="mt-1.5 text-sm text-gray-400 leading-relaxed max-w-2xl">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
